import { render, staticRenderFns } from "./CompetitionLayout.vue?vue&type=template&id=02d2b210&scoped=true"
import script from "./CompetitionLayout.vue?vue&type=script&lang=ts"
export * from "./CompetitionLayout.vue?vue&type=script&lang=ts"
import style0 from "./CompetitionLayout.vue?vue&type=style&index=0&id=02d2b210&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d2b210",
  null
  
)

export default component.exports